export function removeRegisterHeaders({ headers }, isRegimeDraftLocked) {
    if (!isRegimeDraftLocked) return

    const idsToRemove = ["remove", "synchronise"]
    for (let i = headers.length - 1; i >= 0; i--) {
        if (idsToRemove.includes(headers[i].id)) {
            headers.splice(i, 1)
        }
    }
}
